"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLengthAbove = void 0;
var isLengthAbove = function (value, length) {
    return value.length >= length;
};
exports.isLengthAbove = isLengthAbove;
//# sourceMappingURL=isLengthAbove.js.map